import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";

export async function serviceGetProgramDashboardTotalReward(params) {
  return await postRequest("analytics/engagement/rewards/total", params);
}
export async function serviceGetProgramDashboardCity(params) {
  return await postRequest("analytics/city/enrollment", params);
}
export async function serviceGetProgramDashboardReward(params) {
  return await postRequest("analytics/program/performance/counts", params);
}
export async function serviceGetProgramDashboardEnrollment(params) {
  return await postRequest("analytics/enrollment/modes", params);
}
export async function serviceGetProgramDashboardDrop(params) {
  return await postRequest("analytics/enrollment/trend", params);
}
export async function serviceGetProgramDashboardCityWise(params) {
  return await postRequest("analytics/city/trend", params);
}
export async function serviceGetProgramDashboardDoctorWise(params) {
  return await postRequest("analytics/doctor/trend", params);
}
export async function serviceGetProgramDashboardMedicineRefill(params) {
  return await postRequest("analytics/medicine/trend", params);
}
export async function serviceGetProgramDashboardMedReminder(params) {
  return await postRequest("analytics/program/medicine/reminders", params);
}
export async function serviceGetProgramDashboardMap(params) {
  return await postRequest("analytics/state/enrollment", params);
}
export async function serviceProgramEnrollmentExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/program/enrollment/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceProgramTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/program/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}
export async function serviceDoctorEnrollTrendExport (params,token) {  
    return await fetch(constants.DEFAULT_APP_URL+"analytics/doctor/enrollment/trend/export", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token
    },
    body: JSON.stringify({
      ...params
    }),
  });
}